<script>

  import Container from "./components/Container.svelte";
  // import JoinWaitlist from "./components/JoinWaitlist.svelte";

  // export let user;
  // export let selectedUse;
</script>

<Container>
  <h1>Sorry, we're still in private beta</h1>

  <h3>We've registered your email and will contact you as soon as we can let you in</h3>

  <!-- <JoinWaitlist user={user} selectedUse={selectedUse}/> -->
</Container>